














import { defineComponent, ref } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "Accordion",
  components: { BaseButton },
  props: {
    safeMode: { type: Boolean },
    scrollOnClose: { type: Boolean },
  },
  setup(props) {
    const showContent = ref(false);
    const content = ref();
    const accordion = ref();
    const onActivator = () => {
      showContent.value = !showContent.value;
    };

    const onLeave = () => {
      if (props.scrollOnClose && accordion.value) {
        const top = accordion.value.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight) {
          accordion.value.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    return { showContent, onActivator, content, accordion, onLeave };
  },
});
